import * as React from 'react';
import { useCallback } from 'react';
import { useInterval } from '../core/hooks/useInterval';
import { useDispatch } from 'react-redux';
import { useAppState } from '../core/redux/hooks';
import { TIME } from '../language/time';
import { loadCurrentStatusAction } from './loadCurrentStatusAction';
import { IS_DEV_ENV } from '../core/windowProps';


type Props = {};


/**
 * ProjectStatusPoller: a non-rendering component that polls the server for project status changes so that the portal
 * renders the most up-to-date information about the current project
 */
const ProjectStatusPoller: React.FC<Props> = props => {
  const dispatch = useDispatch();

  const participantId = useAppState(state => state.auth.currentUser?.personId ?? 0);
  const projectId     = useAppState(state => state.projectSummary?.projectId ?? 0);
  let refreshMs       = useAppState(state => (state.config?.refreshSeconds || 5) * TIME.S);

  // When testing locally, it's irritating when this is running every 5 seconds
  if (IS_DEV_ENV) {
    refreshMs = 200 * TIME.M;
  }

  const doRefresh = useCallback(
    () => (refreshMs > 0 && projectId > 0 && participantId > 0) && (
      dispatch(loadCurrentStatusAction(projectId, participantId))
    ),
    [projectId, participantId, refreshMs, dispatch],
  );
 
  useInterval(doRefresh, refreshMs);

  return null;
};

export default ProjectStatusPoller;
